//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import md5 from 'js-md5'
import { Toast } from 'mint-ui'
export default {
  name: 'user-info-page',
  data() {
    return {
      form: {
        old_password: '',
        renew_password: '',
        new_password: '',
      },
      popupVisible: false,
    }
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted: function () {
    this.form = Object.assign({}, this.form, this.user)
  },
  methods: {
    submit () {
      if (!this.form.old_password) {
        return Toast({
          message: '請填寫原密碼',
          duration: 3000
        })
      }
      if (!this.form.renew_password) {
        return Toast({
          message: '請填確認密碼',
          duration: 3000
        })
      }
      if (!this.form.new_password) {
        return Toast({
          message: '請填寫新密碼',
          duration: 3000
        })
      }
      if (this.form.renew_password != this.form.new_password) {
        return Toast({
          message: '新密碼與確認密碼不壹致，請重新輸入',
          duration: 3000
        })
      }
      const body = Object.assign({}, this.form)
      body.old_password = md5(this.form.old_password)
      body.new_password = md5(this.form.new_password)
      this.$store.httpDispatch({})('updateUserPass', body).then((res) => {
        const { code, data } = res.data
        if (code === 0) {
          Toast({
            message: `修改成功`,
            duration: 5000
          })
        }
      })
      .catch((err) => {
        if (err.data.code === 4010001) {
          console.log(err)
          Toast({
            message: `${err.data.code}: 原密碼錯誤`,
            duration: 5000
          })
        } else {
          console.log(err)
          Toast({
            message: `${err.data.code}: ${err.data.msg}`,
            duration: 5000
          })

        }
      })
    }
  }
}
